module.exports = {
      id: "arrow-usage",
      viewBox: "0 0 15 10",
      url: __webpack_public_path__ + "img/icons.91580017.svg#arrow-usage",
      toString: function () {
        return this.url;
      }
    }